// docs: https://github.com/altostra/type-validations#readme
import { objectOf, arrayOf, anyOf } from "@altostra/type-validations";
import { string, boolean, any, nullOrUndefined, number } from "@altostra/type-validations/lib/primitives";

const isConstraint = objectOf({
  id: string,
  display_name: string,
  description: anyOf(string, nullOrUndefined),
  dimension: string,
  applied_groups: arrayOf(string),
  negate_expression: boolean,
  matching_conditions: objectOf({
    expression: any,
    human_readable: string,
  }),
  active: boolean,
  created_at: string,
  updated_at: string,
});

export const isGetDecisioningStudioAgentsAppGroupIdDsaIdConstraintsResult = arrayOf(isConstraint);

export const isGetDataTableDecisioningStudioAgentsAppGroupIdDsaIdConstraintsResult = objectOf({
  hits: number,
  results: arrayOf(isConstraint),
});
